import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function PremiumNavbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const navLinks = [
    { label: "Home", to: "/" },
    { label: "Tools", to: "/tools" },
    { label: "Investments", to: "/investments" },
    { label: "SIPs", to: "/sips" },
    { label: "Mutual Funds", to: "/mutual-funds" },
    { label: "Portfolio", to: "/portfolio" },
    { label: "Reports", to: "/reports" },
  ];

  const legalLinks = [
    { label: "Privacy", to: "/privacy-policy" },
    { label: "Terms", to: "/terms" },
    { label: "Disclaimer", to: "/disclaimer" },
  ];

  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-50 border-b border-emerald-900/10 bg-white/80 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
        {/* Brand */}
        <Link to="/" className="flex items-center gap-2 font-semibold text-slate-900">
          <div className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-950 text-white shadow-sm">O</div>
          <span>OjoVest</span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-6 md:flex">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={cn(
                "text-sm font-medium transition",
                isActive(l.to) ? "text-emerald-950" : "text-slate-700 hover:text-emerald-950"
              )}
            >
              {l.label}
            </Link>
          ))}

          <div className="mx-1 h-5 w-px bg-emerald-900/15" />

          {legalLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={cn(
                "text-sm font-medium transition",
                isActive(l.to) ? "text-emerald-950" : "text-slate-700 hover:text-emerald-950"
              )}
            >
              {l.label}
            </Link>
          ))}

          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-950 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-900 focus:outline-none focus:ring-2 focus:ring-emerald-200"
          >
            Get started <ArrowRight className="h-4 w-4" />
          </Link>
        </nav>

        {/* Mobile menu button */}
        <button
          type="button"
          aria-label="menu"
          onClick={() => setOpen((s) => !s)}
          className="inline-flex items-center justify-center rounded-xl border border-emerald-900/15 p-2 md:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="border-t border-emerald-900/10 bg-white md:hidden">
          <div className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-3">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={cn(
                  "rounded-lg px-3 py-2 text-sm font-medium",
                  isActive(l.to) ? "bg-emerald-50 text-emerald-950" : "text-slate-700 hover:bg-emerald-50"
                )}
              >
                {l.label}
              </Link>
            ))}

            <div className="my-2 h-px w-full bg-emerald-900/10" />

            {legalLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={cn(
                  "rounded-lg px-3 py-2 text-sm font-medium",
                  isActive(l.to) ? "bg-emerald-50 text-emerald-950" : "text-slate-700 hover:bg-emerald-50"
                )}
              >
                {l.label}
              </Link>
            ))}

            <Link
              to="/register"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-950 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-900"
            >
              Get started <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
